export default __webpack_public_path__ + "static/media/product_img2.1c7bb9fd.png";